__turbopack_context__.v({
  "active": "TileSwiper-module-scss-module__LSmfDG__active",
  "activePage": "TileSwiper-module-scss-module__LSmfDG__activePage",
  "author": "TileSwiper-module-scss-module__LSmfDG__author",
  "authorAvatar": "TileSwiper-module-scss-module__LSmfDG__authorAvatar",
  "authorImg": "TileSwiper-module-scss-module__LSmfDG__authorImg",
  "authorInfo": "TileSwiper-module-scss-module__LSmfDG__authorInfo",
  "authorWrapper": "TileSwiper-module-scss-module__LSmfDG__authorWrapper",
  "contentWrapper": "TileSwiper-module-scss-module__LSmfDG__contentWrapper",
  "controls": "TileSwiper-module-scss-module__LSmfDG__controls",
  "ctaLink": "TileSwiper-module-scss-module__LSmfDG__ctaLink",
  "currentProgress": "TileSwiper-module-scss-module__LSmfDG__currentProgress",
  "darkTheme": "TileSwiper-module-scss-module__LSmfDG__darkTheme",
  "disabled": "TileSwiper-module-scss-module__LSmfDG__disabled",
  "industryReadMoreCta": "TileSwiper-module-scss-module__LSmfDG__industryReadMoreCta",
  "navButton": "TileSwiper-module-scss-module__LSmfDG__navButton",
  "navigation": "TileSwiper-module-scss-module__LSmfDG__navigation",
  "pagination": "TileSwiper-module-scss-module__LSmfDG__pagination",
  "paginationDot": "TileSwiper-module-scss-module__LSmfDG__paginationDot",
  "postDate": "TileSwiper-module-scss-module__LSmfDG__postDate",
  "prevArrow": "TileSwiper-module-scss-module__LSmfDG__prevArrow",
  "progressBar": "TileSwiper-module-scss-module__LSmfDG__progressBar",
  "reportsAccentCorner": "TileSwiper-module-scss-module__LSmfDG__reportsAccentCorner",
  "researchTile": "TileSwiper-module-scss-module__LSmfDG__researchTile",
  "slideControls": "TileSwiper-module-scss-module__LSmfDG__slideControls",
  "sliderWrapper": "TileSwiper-module-scss-module__LSmfDG__sliderWrapper",
  "tile": "TileSwiper-module-scss-module__LSmfDG__tile",
});
